module.exports = __webpack_public_path__ + "static/img/reg_tesn_15v-1.3cdd70e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/reg_tesn_15v-1.svg
// module id = dOao
// module chunks = 0